import join from 'lodash/join'
import React, { FC } from 'react'

import { ImageV2 } from '@Components/Image'
import { Asset } from '@Generated/graphql'

export const ImageVertical: FC<{ asset?: Asset, index: number, title: string }> = ({
  asset,
  index,
  title,
}) => {
  if (!asset) {
    return null
  }

  return (
    <div
      css={{
        position: 'relative',
        width: 78,
        height: 78,
      }}
    >
      <ImageV2
        alt={`${title || ''} - ${index + 1} - ${join(asset.tags, ' ')}`.trim()}
        layout="fill"
        loading={index <= 5 ? 'eager' : 'lazy'}
        objectFit="contain"
        objectPosition="center center"
        priority={index === 0}
        sizes="78px"
        src={asset.url}
      />
    </div>
  )
}
